import orderBy from 'lodash/orderBy'
import getCollection from '../../utils/db/getCollection'

export const loadSelectableBrands = () =>
  getCollection({ path: 'brands', docIdName: 'id' }).then((brands) =>
    orderBy(
      brands
        .filter((brand) => brand.isArchived !== true && brand.name?.trim())
        .map((brand) => ({
          id: brand.id,
          name: brand.name.trim(),
        })),
      ['name'],
      ['asc']
    )
  )

export default loadSelectableBrands
